"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetPrevPath = void 0;
const react_1 = require("react");
const _1 = require(".");
function useSetPrevPath(path) {
    const [p, setP] = (0, react_1.useState)(path !== null && path !== void 0 ? path : '/');
    const [, setPrevPath] = (0, _1.useSessionStorage)('prevPath');
    const prevValue = (0, _1.usePreviousValue)(p);
    (0, react_1.useEffect)(() => {
        if (prevValue) {
            setPrevPath(prevValue);
        }
    }, [prevValue, setPrevPath]);
    return setP;
}
exports.useSetPrevPath = useSetPrevPath;
